import { Image } from "./image";
import React, { useState } from "react";
import { Tab } from "./tab";
import { Pages } from "./pages";
import { ImageModal } from "./image-modal";

const chunkArray = (arr, size) =>
  arr.reduce(
    (acc, _, i) => (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc),
    []
  );

export const Gallery = ({ data, tab, setTab, page, setPage, length }) => {
  const rows = data ? chunkArray(data, 6) : [];
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (imageUrl, imageTitle) => {
    setSelectedImage({ url: imageUrl, title: imageTitle });
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <div id="gallery" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
          <Tab tab={tab} setTab={setTab} />
        </div>
        {rows.length > 0
          ? rows.map((row, rowIndex) => (
              <div className="row portfolio-items" key={rowIndex}>
                {row.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-6 col-sm-4 col-md-2"
                  >
                    <Image
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                      title={d.title}
                      onImageClick={handleImageClick}
                    />
                  </div>
                ))}
              </div>
            ))
          : "Loading..."}
        <div className="container">
          <Pages page={page} setPage={setPage} length={length} />
        </div>
      </div>
      {selectedImage && (
        <ImageModal
          imageUrl={selectedImage.url}
          imageName={selectedImage.title}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};
